import type { AllRouteEndpoints } from "../routeTypes";

/**
 * Given a list of endpoint strings, return a partial match of the root cache key that we need to invalidate queries
 *
 * The root cache key consists of an object `{ cacheKey, appGroupId }` for each GET endpoint. react-query supports partial
 * key matching, so a cache key of `{ cacheKey }` will invalidate all the caches for every app group.
 * @param invalidationQueryKeys
 * @returns
 */
export const getInvalidateCacheKeys = (invalidationQueryKeys: AllRouteEndpoints | AllRouteEndpoints[]) => {
  // cache keys are stored along with the current app group id in a `{ cacheKey: "key", appGroupId: "id" }` structure.
  // we can clear all of them via `{ cacheKey: "key" }` thanks to react-query's sophisticated cache key handling
  const keys = Array.isArray(invalidationQueryKeys) ? invalidationQueryKeys : [invalidationQueryKeys];
  const cacheKeysToInvalidate = keys.map((cacheKey) => ({ cacheKey }));
  return cacheKeysToInvalidate;
};
